// Module
var code = `<div class="svc-scroll__wrapper">
    <div class="svc-scroll__scroller sv-drag-target-skipped" data-bind="event: { scroll: () => model.onScrollContainer()}">
        <div class="svc-scroll__container">
            <!-- ko template: { nodes: \$componentTemplateNodes, data: \$parent } --><!-- /ko -->
        </div>
    </div>
    <div class="svc-scroll__scrollbar" data-bind="event: { scroll: () => model.onScrollScrollbar()}">
        <div class="svc-scroll__scrollbar-sizer">
        </div>
    </div>
</div>`;
// Exports
export default code;